import { Attachment } from '@otp/icons';
import { Button, ButtonGroup, Card, Chip, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import {
  UpdateWttpQuestionnaireQuestionResponseDto,
  WttpQuestion,
  WttpQuestionResponse,
  WttpQuestionResponseStatus,
} from 'src/graphql/generated/graphql';
import { WttpQuestionnaireResponseQuestionStatus } from './question-status';

type WttpQuestionnaireResponseQuestionItemProps = {
  order: number;
  question: Partial<WttpQuestion>;
  response?: Partial<WttpQuestionResponse>;
  onUpdateWttpQuestionResponse: (
    questionResponse: UpdateWttpQuestionnaireQuestionResponseDto,
  ) => void;
  onOpenQuestionDetails: () => void;
  readonly?: boolean;
};

export const WttpQuestionnaireResponseQuestionItem = ({
  order,
  question,
  response,
  onUpdateWttpQuestionResponse,
  onOpenQuestionDetails,
  readonly = false,
}: WttpQuestionnaireResponseQuestionItemProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question-response',
  });

  const categoryName = question.category?.name;
  const fileAssets = question.fileAssets || [];
  const responseStatus = response?.status;

  const onSkip = () => {
    onUpdateWttpQuestionResponse({
      questionId: question.id,
      status: WttpQuestionResponseStatus.Skipped,
    });
  };

  const onOkay = () => {
    onUpdateWttpQuestionResponse({
      questionId: question.id,
      status: WttpQuestionResponseStatus.Okay,
    });
  };

  return (
    <Card className="flex flex-col w-full gap-3 bg-white">
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row gap-2">
          <Chip label={categoryName} />
          {fileAssets.length > 0 && <Attachment />}
        </div>
        <WttpQuestionnaireResponseQuestionStatus status={responseStatus} />
      </div>
      <div className="flex flex-row gap-2 items-start ps-1">
        <Typography variant="subtitle1">{order + 1}.</Typography>
        <Typography className="flex-grow" variant="subtitle1">
          {question.title}
        </Typography>
        <Button
          variant="contained"
          className="min-w-0 w-8 h-8 self-center"
          onClick={onOpenQuestionDetails}
        >
          &gt;
        </Button>
      </div>
      {!readonly && !response && (
        <ButtonGroup variant="contained" disableElevation fullWidth>
          <Button onClick={onSkip}>{t('skip')}</Button>
          <Button onClick={onOkay}>{t('no-issues')}</Button>
        </ButtonGroup>
      )}
    </Card>
  );
};

export default WttpQuestionnaireResponseQuestionItem;
